import React from "react";
import { Outlet } from "react-router-dom";
import Banner from "../components/Banner/Banner";

function DraftRoomLayout() {
  return (
    <>
      <Banner />
      <Outlet />
    </>
  );
}

export default DraftRoomLayout;
